/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Event_Related_LabelInputs */

const en_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-related`)
};

const fr_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lie a un evenement`)
};

const de_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ereignisbezogen`)
};

const it_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correlato all'evento`)
};

const ru_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событийные`)
};

const es_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado con eventos`)
};

const zh_cn2_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件相关`)
};

const ja_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント関連`)
};

const hi_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`घटना से संबंधित`)
};

const pt_pt2_manual_qc_event_related_label = /** @type {(inputs: Manual_Qc_Event_Related_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relacionado a eventos`)
};

/**
* | output |
* | --- |
* | "Event-related" |
*
* @param {Manual_Qc_Event_Related_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_event_related_label = /** @type {((inputs?: Manual_Qc_Event_Related_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Event_Related_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_event_related_label(inputs)
	if (locale === "de") return de_manual_qc_event_related_label(inputs)
	if (locale === "it") return it_manual_qc_event_related_label(inputs)
	if (locale === "ru") return ru_manual_qc_event_related_label(inputs)
	if (locale === "es") return es_manual_qc_event_related_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_event_related_label(inputs)
	if (locale === "ja") return ja_manual_qc_event_related_label(inputs)
	if (locale === "hi") return hi_manual_qc_event_related_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_event_related_label(inputs)
	return en_manual_qc_event_related_label(inputs)
});